export default class AdminMedicationReports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/medication`, {
      params
    })
  }

  listDrugs(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/medication/drug-list`, {
      params
    })
  }

  getChart(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/medication/chart`, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/medication/export`, {
      params,
      responseType: "blob"
    })
  }
}
